/**
 * sterntaler-personalisierung-attribute.js
 * ------------------------------------------------------------------
 * Setzt/löscht das Cart-Attribut "personalisierung" ("ja"/"") je
 * nachdem, ob noch mindestens eine Warenkorbposition mit
 * Personalisierung vorhanden ist. Wird für die native Shopify-
 * Delivery-Customization ("Hide delivery methods" -> Cart rules)
 * genutzt, um die Versandart "Express-Bearbeitung" nur anzuzeigen,
 * wenn tatsächlich etwas Personalisiertes im Warenkorb liegt.
 *
 * WICHTIG: merged beim Schreiben immer zuerst die aktuellen
 * cart.attributes (z.B. die von sterntaler-lp-tracking.liquid
 * gesetzten lp_entry/lp_last/etc.), damit nichts überschrieben wird –
 * gleiches Muster wie in sterntaler-lp-tracking.liquid bereits
 * verwendet.
 *
 * In layout/theme.liquid direkt NACH sterntaler-cart-incentives.js
 * einbinden:
 *   <script src="{{ 'sterntaler-personalisierung-attribute.js' | asset_url }}" defer></script>
 * ------------------------------------------------------------------
 */
(() => {
  if (window.__StPersoAttrInit) return;
  window.__StPersoAttrInit = true;

  var PERSONALIZATION_PROPERTY_KEYS = [
    'Personalisierung',
    '_Personalisierung links',
    '_Personalisierung rechts',
  ];
  var ATTRIBUTE_KEY = 'personalisierung';

  var lastSyncedValue = null; // vermeidet unnötige Requests bei unverändertem Zustand
  var inFlight = false;
  var pendingRerun = false; // es gab eine Cart-Änderung, während ein Sync noch lief

  function cartHasPersonalization(cart) {
    return (cart.items || []).some(function (item) {
      var props = item.properties || {};
      return PERSONALIZATION_PROPERTY_KEYS.some(function (key) {
        return !!(props[key] && String(props[key]).trim());
      });
    });
  }

  function sync() {
    if (inFlight) {
      // Läuft gerade schon ein Sync -> diese Änderung nicht verwerfen,
      // sondern direkt nach Abschluss des aktuellen Laufs nachholen.
      pendingRerun = true;
      return;
    }
    inFlight = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var shouldBeSet = cartHasPersonalization(cart);
        var attrs = cart.attributes || {};
        var keyExists = Object.prototype.hasOwnProperty.call(attrs, ATTRIBUTE_KEY);
        var currentValue = keyExists ? attrs[ATTRIBUTE_KEY] : null;
        var currentlySet = currentValue === 'ja';

        // Wichtig: auch schreiben, wenn der Key komplett fehlt (nicht nur
        // wenn sich der Wert ändert) – ein fehlender Key wird von der
        // "Hide delivery methods"-Cart-Rule ("Is not ja") offenbar NICHT
        // wie ein leerer Wert behandelt, sondern wie "Bedingung trifft
        // nicht zu" -> die Versandart bliebe sonst fälschlich sichtbar.
        var needsWrite = shouldBeSet !== currentlySet || !keyExists;

        if (!needsWrite) {
          lastSyncedValue = shouldBeSet;
          return;
        }

        // Bestehende Attribute (z.B. lp-Tracking) immer mit übernehmen,
        // nur unseren eigenen Key ändern.
        var mergedAttributes = Object.assign({}, cart.attributes || {});
        // "nein" statt "" verwenden: Shopify behandelt einen leeren String
        // beim Schreiben offenbar als "Attribut entfernen", nicht als
        // "Attribut mit leerem Wert setzen" – der Key würde dann nie
        // dauerhaft existieren.
        mergedAttributes[ATTRIBUTE_KEY] = shouldBeSet ? 'ja' : 'nein';

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: mergedAttributes }),
        }).then(function () {
          lastSyncedValue = shouldBeSet;
        });
      })
      .catch(function () {
        // Netzwerkfehler bewusst still ignorieren – nächstes Cart-Event
        // versucht es automatisch erneut.
      })
      .finally(function () {
        inFlight = false;
        if (pendingRerun) {
          pendingRerun = false;
          sync();
        }
      });
  }

  var debounceTimer;
  function scheduleSync(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, delay || 150);
  }

  // ── Gleiche Trigger-Basis wie sterntaler-cart-incentives.js,
  //    damit garantiert jede Warenkorb-Änderung erfasst wird. ──
  ['cart:refresh', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleSync(100); });
  });
  window.addEventListener('sterntaler-cart-update', function () { scheduleSync(100); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) {
      scheduleSync(150);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-remove-button,[data-cart-remove],[data-remove],button[name="remove"]')) {
      scheduleSync(200);
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    var a = f.getAttribute('action') || f.action || '';
    if (a.indexOf('/cart/add') !== -1) scheduleSync(400);
  });
  try {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string' ? input : input.url) || ''; } catch (e) {}
      var p = origFetch.apply(this, arguments);
      // Bewusst NUR /cart/add und /cart/change abfangen, NICHT /cart/update –
      // sonst würde der eigene Attribut-Schreibvorgang (und der von
      // sterntaler-lp-tracking.liquid) sich selbst re-triggern.
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1) {
        p.finally(function () { scheduleSync(150); });
      }
      return p;
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSync(50); });
  } else {
    scheduleSync(50);
  }
})();